/* eslint-disable no-undef */

define(['BuildStatus/BuildStatusMain',
    'dojo/io-query',
    'dojo/dom',
    'dojo/domReady!'
], function (MainApp, ioQuery, dom) {
// Get a node from the HTML Doc
    var rootNode = dom.byId('root');

    var paramObj = ioQuery.queryToObject(
        decodeURIComponent(dojo.doc.location.search.slice(1)));

    var app = new MainApp(rootNode, paramObj);
    // Start Your Widget
    app.start();
});
